<router-outlet></router-outlet>
<div
  class="main-background"
  [ngClass]="{ dark: darkMainBackground$ | async }"
  [ngStyle]="{
    'background-image': 'url(' + (mainBackgroundUrl$ | async) + ')'
  }"
></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="
    !(getGameInitialized$ | async) ||
    (getDefaultAssetsLoaded$ | async)! < 100 ||
    !!(isOffline$ | async) ||
    !!(autoLogin$ | async) ||
    !!(layoutHandsetLandscape$ | async)?.matches
  "
  [cdkConnectedOverlayOrigin]="{ x: 0, y: 0 }"
  cdkConnectedOverlayPanelClass="init-loader-panel"
>
  <ng-container
    *ngIf="!(layoutHandsetLandscape$ | async)?.matches; else rotateToPortrait"
  >
    <ng-container
      *ngIf="
        !(getGameInitialized$ | async) ||
          (getDefaultAssetsLoaded$ | async)! < 100;
        else offline
      "
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <app-init-loader></app-init-loader>

        <div style="color: #fff; font-size: 24px">
          {{ getDefaultAssetsLoaded$ | async }}%
        </div>
      </div>
    </ng-container>

    <ng-template #offline>
      <ng-container *ngIf="!!(isOffline$ | async); else autoLogin">
        <div>
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <div style="color: #fff; font-size: 24px">
              Reconnecting 

              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="width: 48px; height: 48px"
                fill="currentColor"
                class="bi bi-wifi-off"
                viewBox="0 0 36 36"
              >
                <path
                  d="M10.706 3.294A12.6 12.6 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.52.52 0 0 0 .668.05A11.45 11.45 0 0 1 8 4q.946 0 1.852.148zM8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065 8.45 8.45 0 0 1 3.51-1.27zm2.596 1.404.785-.785q.947.362 1.785.907a.482.482 0 0 1 .063.745.525.525 0 0 1-.652.065 8.5 8.5 0 0 0-1.98-.932zM8 10l.933-.933a6.5 6.5 0 0 1 2.013.637c.285.145.326.524.1.75l-.015.015a.53.53 0 0 1-.611.09A5.5 5.5 0 0 0 8 10m4.905-4.905.747-.747q.886.451 1.685 1.03a.485.485 0 0 1 .047.737.52.52 0 0 1-.668.05 11.5 11.5 0 0 0-1.811-1.07M9.02 11.78c.238.14.236.464.04.66l-.707.706a.5.5 0 0 1-.707 0l-.707-.707c-.195-.195-.197-.518.04-.66A2 2 0 0 1 8 11.5c.374 0 .723.102 1.021.28zm4.355-9.905a.53.53 0 0 1 .75.75l-10.75 10.75a.53.53 0 0 1-.75-.75z"
                />
              </svg>
            </div>

            <app-spinner *ngIf="autoLogin$ | async" />
          </div>
        </div>
      </ng-container>
      <ng-template #autoLogin>
        <ng-container *ngIf="!!(autoLogin$ | async)">
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <div style="color: #fff; font-size: 24px">
              Loading... <app-spinner />
            </div>
          </div>
        </ng-container>
      </ng-template>
    </ng-template>
  </ng-container>

  <ng-template #rotateToPortrait>

    <div style="display: flex; flex-direction: column; align-items: center;">
      <div style="color: #fff; font-size: 18px; display: flex; align-items: center;">
        <i class="bi bi-tablet-landscape" style="font-size: 36px; margin-right: 10px;"></i> landscape mode isn't supported
      </div>
    </div>


  </ng-template>
  
</ng-template>
